// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2010":"ceabaa5bd9102941","2143":"7341acd2fa6c2bdc","9727":"b8c624b1c8f74e73"}[chunkId] + ".css";
};